import Loadable from '@townsquare/loadable';

export const EmojiPreviewer = Loadable({
  loader: () => import(/* webpackChunkName: "emoji-previewer" */ './components/PickerModal/EmojiPreviewer'),
  loading: () => null,
});
